module.exports = __webpack_public_path__ + "static/media/preloader.c114fda3.gif";